import React, { Component } from 'react';
import Dropdown from 'react-bootstrap/Dropdown'

class DropdownMenu extends Component {

  constructor(props) {
    super(props);
    this.state = {
      display_menu: false,
      on_click_function: null,
      event: null,
    }
  }

  render() {

    let style          = this.props.style;
    let className      = this.props.className;
    let toggle_element = this.props.toggle_element;

    let menu_element   = this.props.menu_element;
    let menu_style     = this.props.menu_style || {};

    return <div>
    <Dropdown>
        <Dropdown.Toggle as={this.getCustomToggle(style, className, toggle_element)} id="dropdown-custom-components"></Dropdown.Toggle>
        <Dropdown.Menu as={this.getCustomMenu(menu_element, menu_style)}></Dropdown.Menu>
     </Dropdown>
     </div>
  }

  getCustomMenu = (menu_element, menu_style) => {
   return React.forwardRef(({ className }, ref) => {
     let class_name = this.state.display_menu ? 'button-default show' :  'button-default';
        return (
          <span ref={ref}
                className={ className }
                style={{ minWidth: 10, padding: 0, paddingTop: 0, borderWidth: 0, borderRadius: 0, ...menu_style }}
                onClick={ () => {
                  if (this.state.on_click_function && this.state.event) {
                    this.state.on_click_function(this.state.event);
                  }
                }}>
           { menu_element }
          </span>
        );
      },
    );
  }

  getCustomToggle = (style, className, toggle_element) => {
    return React.forwardRef(({ children, onClick }, ref) => (
      <div ref={ref}
         className={className}
         style={style}
         onClick={(e) => {
          e.preventDefault();
          onClick(e);
          this.setState({ ...this.state, on_click_function: onClick, event: e });
         }}
      >
        { toggle_element }
      </div>
    ));
  }

}

export default DropdownMenu
